import { useEffect, useCallback } from 'react';

export interface UseBackButtonOptions {
  onClick?: () => void;
  isVisible?: boolean;
}

export function useTelegramBackButton({
  onClick,
  isVisible = true
}: UseBackButtonOptions = {}) {
  const backButton = window.Telegram?.WebApp?.BackButton;

  const show = useCallback(() => {
    if (!backButton) return;
    backButton.show();
  }, [backButton]);

  const hide = useCallback(() => {
    if (!backButton) return;
    backButton.hide();
  }, [backButton]);

  // Initialize button when component mounts
  useEffect(() => {
    if (!backButton) return;

    if (isVisible) {
      show();
    } else {
      hide();
    }

    return () => {
      hide();
    };
  }, [backButton, isVisible, show, hide]);

  // Handle click events
  useEffect(() => {
    if (!backButton || !onClick) return;

    const handleClick = () => {
      onClick();
    };

    backButton.onClick(handleClick);

    return () => {
      backButton.offClick(handleClick);
    };
  }, [backButton, onClick]);

  return {
    isAvailable: !!backButton,
    show,
    hide
  };
}
